import { useTranslation } from "@redotech/redo-i18n";
import { AdjustmentAmountOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import type { AdjustmentAmountState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const AdjustmentAmountDetails = memo(function AdjustmentAmountDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<AdjustmentAmountState>) {
  const { t } = useTranslation();
  const adjustmentAmountOptions: RedoListItem<AdjustmentAmountOption>[] =
    useMemo(
      () =>
        Object.values(AdjustmentAmountOption).map((option) => ({
          id: option,
          value: option,
          type: "text" as const,
          text:
            option === AdjustmentAmountOption.LESS_THAN
              ? t("Less than")
              : option === AdjustmentAmountOption.GREATER_THAN
                ? t("Greater than")
                : t("Equals"),
        })),
      [t],
    );

  const selectedOption = state.adjustmentAmountOption
    ? adjustmentAmountOptions.find(
        (option) => option.value === state.adjustmentAmountOption,
      )
    : undefined;

  return (
    <>
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        flexGrow
        label={t("Match type")}
        options={adjustmentAmountOptions}
        optionSelected={({ item }) =>
          setState({ ...state, adjustmentAmountOption: item.value })
        }
        placeholder={t("Select match type...")}
        selectedItem={selectedOption}
        size="xs"
      />
      <RedoTextInput
        IconLeading={() => <>$</>}
        inputTypeHint="number"
        label={t("Total adjustment amount of selected items")}
        onBlur={() =>
          setState({
            ...state,
            adjustmentAmount: (+state.adjustmentAmount).toFixed(2),
          })
        }
        setValue={(e) => setState({ ...state, adjustmentAmount: e })}
        state={disabled ? "readonly" : "default"}
        value={state.adjustmentAmount}
      />
    </>
  );
});
